import React, { useEffect } from 'react';
import './Home.css';

const Home = () => {
  useEffect(() => {
    document.body.id = 'home';
  }, []);

  return (
    <>      
      <section className="message">
        <p>RubyMagic株式会社のウェブサイトにお越しいただき、誠にありがとうございます。</p>
        <p>私たちが大切にしているのは、<ruby>Jamais vu<rp>(</rp><rt>ジャメヴュ</rt><rp>)</rp></ruby> ── 見慣れた世界に新しい意味を見つけ、ワクワクする体験へと変換することです。</p>
        <p>当社は、WEBエンジニアリング業務を主軸に、アルゴリズムを用いたジェネラティブアートの制作・販売、およびオラクルカード等のプロダクト企画・制作を行っております。<br/>
        技術とアートの融合により、新しい価値を創造し、お客様にご満足いただけるサービスを提供することを目指しております。</p>
        <p>2024年11月の設立以来、着実に事業を展開してまいりました。<br/>
        今後も、お客様との信頼関係を大切にしながら、質の高いサービスを提供してまいります。</p>
      </section>

      <hr/>

      <section>
        <h2 data-en="COMPANY">会社概要</h2>

        <dl className="styled-dl">
          <dt>会社名</dt>
          <dd className="border"></dd>
          <dd><ruby>RubyMagic<rp>(</rp><rt>ルビーマジック</rt><rp>)</rp> </ruby>株式会社<br/>（英文名称: Ruby Magic Corporation）</dd>

          <dt>代表者</dt>
          <dd className="border"></dd>
          <dd>代表取締役社長　小川尚子</dd>

          <dt>所在地</dt>
          <dd className="border"></dd>
          <dd>〒150-0001<br/>東京都渋谷区神宮前6丁目23-4<br/>桑野ビル2階</dd>

          <dt>事業内容</dt>
          <dd className="border"></dd>
          <dd>
            <ul>
              <li>WEBエンジニアリング業務（業務委託）</li>
              <li>ジェネラティブアートの制作・販売</li>
              <li>オラクルカード等の企画・制作・販売</li>
            </ul>
          </dd>
          
          <dt>設立年月日</dt>
          <dd className="border"></dd>
          <dd>2024年11月11日</dd>

          <dt>資本金</dt>
          <dd className="border"></dd>
          <dd>200万円</dd>

          <dt>インボイス登録番号</dt>
          <dd className="border"></dd>
          <dd>T6011001165949</dd>

          <dt>取引銀行</dt>
          <dd className="border"></dd>
          <dd>
            <ul>
              <li>三井住友銀行</li>
              <li>住信SBIネット銀行</li>
              <li>PayPay銀行</li>
              <li>あおぞら銀行</li>
            </ul>
          </dd>
        </dl>
      </section>

      <hr/>

      <section>
        <h2 data-en="PRODUCTS">制作実績</h2>
        <p>当社が企画・制作しているプロダクトをご紹介いたします。書店等への卸販売のほか、イベントでの直販も実施しています。</p>
        
        <h3>SPIRA SUURA｜ジェネラティブアートブランド</h3>
        <div className="product-item">
          <a href="https://spirasuura.com/" target="_blank" rel="noopener noreferrer" className="product-link">
            <img src="/img/home/spira-zine.png" alt="SPIRA SUURA ジェネラティブアートプロダクト" className="product-image" />
            <div className="product-info">
              <div className="product-title">SPIRA SUURA</div>
              <div className="product-desc">アルゴリズムを用いて生成するビジュアル表現の制作・販売<br/>受託制作のご相談も承っております。</div>
            </div>
          </a>
        </div>
        <p style={{fontSize: '0.9em', color: '#666', marginTop: '0.5em'}}>※SPIRA SUURAは登録商標です。</p>

        <h3>サビアン占星術カード｜オラクルデッキ</h3>
        <div className="product-item">
          <a href="https://oracle.sabian-calculator.com/" target="_blank" rel="noopener noreferrer" className="product-link">
            <img src="/img/home/sabian-oracle.jpg" alt="Sabian Astrology Oracle Deck サビアン占星術カード" className="product-image" />
            <div className="product-info">
              <div className="product-title">サビアン占星術カード（Sabian Astrology Oracle Deck）</div>
              <div className="product-desc">占星術のシンボル（サビアン）をもとにしたオラクルカードの企画・制作。書店等への卸販売のほか、イベントでの直販も行っています。<br/>お取り扱い（委託・卸等）のご相談も承っております。</div>
            </div>
          </a>
        </div>
        <p>プロダクトのお取り扱い（委託・卸等）をご希望の場合は、<a href="https://forms.gle/sRVrYbVEZMcn6qAEA" target="_blank" rel="noopener noreferrer">お問い合わせフォーム</a>よりご相談ください。</p>
      </section>

      <hr/>

      <section>
        <h2 data-en="CLIENTS">主な取引先</h2>
        <ul>
          <li>ネットイヤーグループ株式会社</li>
          <li>株式会社イーテア</li>
          <li>株式会社ヴィジョナリー･カンパニー</li>
        </ul>
      </section>

      <hr/>

      <section>
        <h2 data-en="CONTACT">お問い合わせ</h2>
        <p><a href="https://forms.gle/sRVrYbVEZMcn6qAEA" target="_blank" rel="noopener noreferrer">こちらのフォーム</a>よりお問い合わせください。</p>
      </section>


    </>
  );
};

export default Home;